import { css } from "emotion";
import H4 from "../../components/global/H4";
import Image from "../../components/Image";
import ColorServices from "../../services/ColorServices";
import config from "../../config";

const faqIcon = require("../../assets/ic_faqs_teal.svg");

const helpDocUrl = config("HELP_DOCS_URL");

const wrapper = css({
  maxWidth: 700,
  margin: "0 auto",
  textAlign: "left",
  marginBottom: 72
});

const heading = css({
  display: "flex",
  alignItems: "center",
  marginBottom: 24,
  img: {
    marginRight: 12
  }
});

const faqLink = css({
  width: "100%",
  textAlign: "left",
  fontSize: 16,
  background: ColorServices.getColor("white"),
  borderRadius: 4,
  display: "block",
  marginBottom: 8,
  padding: "16px 22px",
  "&:hover": {
    textDecoration: "none",
    boxShadow: "0 3px 10px 0 rgba(9, 30, 66, 0.13)"
  }
});

const seeMore = css({
  fontSize: 16,
  fontWeight: 600,
  color: ColorServices.getColor("purple"),
  textDecoration: "underline",
  marginTop: 16,
  display: "block"
});

const FAQS = ({ faqs = [] }) => {
  return (
    <div className={wrapper}>
      <div className={heading}>
        <Image imageURL={faqIcon} alt="" />
        <H4>Frequently asked questions</H4>
      </div>
      {faqs.map(faq => (
        <a href={faq.link} className={faqLink}>
          {faq.text}
        </a>
      ))}
      <a className={seeMore} href={helpDocUrl}>
        See More
      </a>
    </div>
  );
};

export default FAQS;
